import hmImg from './hm-img/index.vue'
import hmApply from './hm-apply/index.vue'
import hmVideo from './hm-video/index.vue'

export default {
  install (Vue) {
    Vue.component('hmImg', hmImg)
    Vue.component('hmApply', hmApply)
    Vue.component('hmVideo', hmVideo)
  }
}



// WEBPACK FOOTER //
// ./src/components/index.js